export default __webpack_public_path__ + "static/media/Mic.f14bcfd0.png";